import { render, staticRenderFns } from "./installing-and-using-the-lib.vue?vue&type=template&id=f396a6e4"
var script = {}
import style0 from "./installing-and-using-the-lib.vue?vue&type=style&index=0&id=f396a6e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports